import ExportPDFButton from "./FinanceProductionPDFDownload.jsx";
export default function Export(props){return <ExportPDFButton {...props} kind={props.kind||"invoice"}/>;}
